// Change the viewport, never the path/rail coordinates.
export function cropArtwork(svg, longestSide) {
  const ns = "http://www.w3.org/2000/svg";
  const element = document.createElementNS(ns, "svg");
  element.style.cssText =
    "position:absolute;visibility:hidden;pointer-events:none;width:1px;height:1px";
  for (const child of svg.children) {
    if (child.name !== "path") continue;
    const path = document.createElementNS(ns, "path");
    for (const name of ["d", "transform", "fill", "fill-rule"])
      if (child.attributes[name] != null)
        path.setAttribute(name, child.attributes[name]);
    element.appendChild(path);
  }
  document.body.appendChild(element);
  try {
    const b = element.getBBox();
    if (
      ![b.x, b.y, b.width, b.height].every(Number.isFinite) ||
      b.width <= 0 ||
      b.height <= 0
    )
      throw new Error("The traced artwork has no measurable area.");
    const scale = longestSide / Math.max(b.width, b.height);
    const size = { width: b.width * scale, height: b.height * scale };
    return {
      svg: {
        ...svg,
        attributes: {
          ...svg.attributes,
          viewBox: `${b.x} ${b.y} ${b.width} ${b.height}`,
          width: `${size.width}mm`,
          height: `${size.height}mm`,
        },
      },
      size,
    };
  } finally {
    element.remove();
  }
}
